<template>
    <div class="slide-preview">
        <design-2021-apprentice-display-html-component
            v-if="slideIn.type === 1"
            :html-content="slideIn.value">
        </design-2021-apprentice-display-html-component>

        <design-2021-apprentice-video-link-player-component
            v-if="slideIn.type === 2"
            :options="playerOptions"
            :src="slideIn.value">
        </design-2021-apprentice-video-link-player-component>

        <img class="slide-image"
             v-if="slideIn.type === 5"
             :src="slideIn.file.image.thumb_path">
    </div>
</template>

<script>
export default {
    name: 'design-2021-apprentice-slide-preview-component',
    props: {
        slideIn: {
            type: Object,
            required: true,
        },
        textBlockIdIn: Number,
        lessonIdIn: Number,
    },
    data() {
        return {
            playerOptions: {
                responsive: true,
                autoplay: false,
                controls: true,
            },
        };
    },
};
</script>

<style scoped lang="scss">
    .slide-image {
        object-fit: cover;
        object-position: center;
        width: 100%;
        height: 100%;
    }
</style>
